<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">基地库存平均存取周期</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">

      <Table :columns="columns" stripe  :data="tableData" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >
      </Table>
    </Card>

  </div>
</template>

<script>
import {
  landBaseAverageCycleApi
} from '@/api/warehouse/warehouseInventoryIn'

export default {
  name: 'landBaseAverageCycleList',
  inject: ['reload'],
  data () {
    return {
      grid: {
        xs: 24,
        sm: 24,
        md: 12,
        lg: 7,
        xl: 7
      },
      tableData: [],
      loading: false,
      columns: [
        {
          title: '基地名称',
          key: 'land_base_name',
          minWidth: 200
        },
        {
          title: '累计入库单数(单)',
          key: 'count',
          minWidth: 180
        },
        {
          title: '累计库存停留时间(天)',
          key: 'cycle_total',
          minWidth: 180
        },
        {
          title: '库存平均存取周期(天)',
          key: 'average_cycle',
          minWidth: 180
        },
      ]
    }
  },
  created () {
    this.loadTableData()
  },
  methods: {
    loadTableData () {
      this.loading = true
      landBaseAverageCycleApi().then(res => {
        this.tableData = res.data
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },

  }
}
</script>
